import { gql } from '@apollo/client';
export const COMMENT_FIELDS = gql `
  fragment CommentFields on Comment {
    id
    clientId
    commentableType
    commentableId
    parentId
    message
    isInternal
    createdAt
    updatedAt
    createdById
    updatedById
    createdBy {
      clientId
      firstName
      lastName
    }
    updatedBy {
      clientId
      firstName
      lastName
    }
    extraData
  }
`;
export const COMMENTS = gql `
  ${COMMENT_FIELDS}
  query COMMENTS($spec: CommentSpec!) {
    comments(spec: $spec) {
      ...CommentFields
    }
  }
`;
export const SAVE_COMMENT = gql `
  ${COMMENT_FIELDS}
  mutation SAVE_COMMENT($input: CommentInput!) {
    saveComment(input: $input) {
      ...CommentFields
    }
  }
`;
export const DELETE_COMMENT = gql `
  ${COMMENT_FIELDS}
  mutation DELETE_COMMENT($id: Int!) {
    deleteComment(id: $id) {
      ...CommentFields
    }
  }
`;
export const TRANSLATE_COMMENT = gql `
  ${COMMENT_FIELDS}
  mutation TRANSLATE_COMMENT($id: Int!) {
    translateComment(id: $id) {
      ...CommentFields
    }
  }
`;
